<div class="spinner-overlay" *ngIf="isLoading">
  <div class="spinner-container">
    <div class="spinner"></div>
    <p *ngIf="message" class="spinner-message">{{message}}</p>
  </div>
</div>